import {env} from '../env'

const init = async () => {
  if (process.env.NODE_ENV !== 'production') return

  const Sentry = await import('@sentry/react')

  const isDev = window.location.hostname.includes('dev')

  Sentry.init({
    environment: isDev ? 'development' : 'production',
    dsn: env().VITE_SENTRY_DNS_URL,
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/portal-united\.dev\.vionlabs\.com/,
      /^https:\/\/dev\.portal\.vionlabs\.com/,
      /^https:\/\/portal\.vionlabs\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // no sample without error
    replaysOnErrorSampleRate: 0.0, // sample rate 100% where errors occur.
  })
}

void init()
